module.exports = __webpack_public_path__ + "img/trash.ac26eaff.svg";